'use strict';

angular.module('mediacloudApp')
    .factory('AuthServerProvider', function loginService($http, $rootScope, $state, localStorageService, $window) {
        return {
            login: function(credentials) {
                var data = 'j_username=' + encodeURIComponent(credentials.username) +
                    '&j_password=' + encodeURIComponent(credentials.password) +
                    '&remember-me=' + credentials.rememberMe + '&submit=Login';
                return $http.post('api/authentication', data, {
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded'
                    }
                }).then(function (response) {
                    var headers = response.headers();
                    localStorageService.set("authToken", headers['x-auth-token']);
                    $http.defaults.headers.common['x-auth-token'] = headers['x-auth-token'];
                    return response;
                });
            },
            logout: function() {
                //Tracker.disconnect();
                // logout from the server
                $http.post('api/logout')
                    .then(function (response) {
                        localStorageService.clearAll();
                        $rootScope.$broadcast('loggedOut');
                        // to get a new csrf token call the api
                        $http.get('api/account');
                        return response;
                    });
            },
            getToken: function () {
                var token = localStorageService.get('token');
                return token;
            },
            hasValidToken: function () {
                var token = this.getToken();
                return !!token;
            }
        };
    });
